import type { ConfiguracaoFiscalModel } from "../models/configuracaoFiscalModel"
import type { ConfiguracaoFiscalAction } from "./configuracaoFiscalActions"
import { ConfiguracaoFiscalActionsTypes } from "./configuracaoFiscalActions"

export function configuracaoFiscalReducer(
    state: ConfiguracaoFiscalModel,
    action: ConfiguracaoFiscalAction
): ConfiguracaoFiscalModel {
    switch (action.type) {
        case ConfiguracaoFiscalActionsTypes.CARREGAR:
            return { ...action.payload }

        case ConfiguracaoFiscalActionsTypes.ATUALIZAR_CAMPO:
            return { ...state, [action.payload.campo]: action.payload.valor }

        case ConfiguracaoFiscalActionsTypes.TOGGLE_FORMA:
            return {
                ...state,
                formas: state.formas.map(f =>
                    f.id === action.payload.id ? { ...f, selecionada: !f.selecionada } : f
                ),
            }

        default:
            return state
    }
}
